export default __webpack_public_path__ + "static/media/seiaf-mt-logo-image.2c189d18.png";